module finadai.services {
	export var NAME = "finadai.services";

	
	export function run() {
		var services = angular.module(NAME, [
			'ngStorage',
			'ui.router',
			finadai.services.util.NAME
		]);
		services.factory(authHttpInterceptorName, AuthHttpInterceptor);
		services.service(AuthService.instanceName, AuthService);
		services.service(AgentsService.instanceName, AgentsService);
		services.service(GrantersService.instanceName, GrantersService);
		services.service(FilesService.instanceName, FilesService);
		services.service(CustomersService.instanceName, CustomersService);
		services.service(NegotiationsService.instanceName, NegotiationsService);
		services.service(PaymentsService.instanceName, PaymentsService);
		services.config(function ($httpProvider:ng.IHttpProvider){
			$httpProvider.interceptors.push(authHttpInterceptorName);
    	// $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
		});
  }
}
finadai.services.run();